import {Component, OnInit} from '@angular/core';
import {DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import {IconProp} from '@fortawesome/fontawesome-svg-core';
import {faExclamationCircle} from '@fortawesome/pro-light-svg-icons/faExclamationCircle';

@Component({
    styleUrls: ['./dialog.component.less'],
    templateUrl: './dialog.component.html',
})
export class DialogComponent implements OnInit {

    public msg?: string;
    public htmlMsg?: string;
    public confirmText: string;
    public cancelText: string;
    public thirdOptionText?: string;
    public icon: IconProp;

    constructor(public ref: DynamicDialogRef, public config: DynamicDialogConfig) {}

    ngOnInit() {
        this.msg = this.config.data.msg;
        this.htmlMsg = this.config.data.htmlMsg;
        this.confirmText = this.config.data.confirmText;
        this.cancelText = this.config.data.cancelText ?? 'Cancel';
        this.thirdOptionText = this.config.data.thirdOptionText;
        this.icon = this.config.data.icon ?? faExclamationCircle;
    }
}
